export default __webpack_public_path__ + "client02.jpg";